import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  fadeOutLeftBigAnimation,
  fadeOutRightBigAnimation,
} from 'angular-animations';
import { escape } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { MemoryCardCompletionDialogComponent } from '../memory-card-completion-dialog/memory-card-completion-dialog.component';


@Component({
  selector: 'app-card-of-the-day',
  templateUrl: './card-of-the-day.component.html',
  styleUrls: ['./card-of-the-day.component.css'],
  animations: [
    fadeOutLeftBigAnimation({duration: 900}),
    fadeOutRightBigAnimation({duration: 900}),
    trigger('flipState', [
      state('active', style({
        transform: 'rotateY(180deg)'
      })),
      state('inactive', style({
        transform: 'rotateY(0)'
      })),
      state('change', style({
        transform: 'rotateY(0)'
      })),
      transition('active => inactive', animate('800ms ease-out')),
      transition('inactive => active', animate('800ms ease-in')),
      transition('change => active', animate('0ms ease-in'))
    ])
  ]
})
export class CardOfTheDayComponent implements OnInit {

  currIndex:any = 0;
  toRight: boolean = false;
  toLeft: boolean =false;
  flip: string = 'inactive';
  isRemebered:any;
  flashCardids:any =[];
  questionsData:any;
  currentQuestionData:any;
  currentQuestionNumber:any = 0;
  cardOftheDayData:any;


  constructor(public selfLearnService: SelfLearnService, public spinner: NgxSpinnerService, public dialog: MatDialog, private router:Router) { }

  ngOnInit(): void {
    this.getBookMarkedFlashCards();
  }

  onRight() {
    this.updateMemoryCard(this.currentQuestionData,true)

    if(this.currentQuestionNumber+1<this.questionsData.length){
      this.isRemebered = true;
      setTimeout(() => {
        this.toRight = true;
        this.isRemebered = null;
        //this.flip = 'inactive';
      }, 200)
      setTimeout(() => {
        this.currIndex = this.currIndex + 1
        this.toRight = false;
      }, 1500);
    this.currentQuestionData = this.questionsData[++this.currentQuestionNumber];}
    else{
      this.isRemebered = true;
      setTimeout(() => {
        this.toRight = true;
        this.isRemebered = null;
       // this.flip = 'inactive';
      }, 200)
      setTimeout(() => {
        this.currIndex = this.currIndex + 1
        this.toRight = false;
      }, 1500);
      setTimeout(() => {
      this.openMemoryCardCompletionDialog()
      },1500);
    }
  }

  onLeft() {
    this.updateMemoryCard(this.currentQuestionData,false)
    this.isRemebered = false;

    
    if(this.currentQuestionNumber+1<this.questionsData.length){
      setTimeout(() => {
        this.toLeft = true;
        this.isRemebered = null;
        //this.flip = 'inactive';
      }, 200)
      setTimeout(() => {
        this.currIndex = this.currIndex + 1
        this.toLeft = false;
      }, 1500);
      this.currentQuestionData = this.questionsData[++this.currentQuestionNumber];}
      else{
        setTimeout(() => {
          this.toLeft = true;
          this.isRemebered = null;
          //this.flip = 'inactive';
        }, 200)
        setTimeout(() => {
          this.currIndex = this.currIndex + 1
          this.toLeft = false;
        }, 1000);
        setTimeout(() => {
          this.openMemoryCardCompletionDialog()
          },1500);
      }
  }

  flipCard(event:any) {
    console.log(event.target.classList[0],'flip')
    if(event.target.classList[0]!='ans-btn'){
      console.log('card flipped')
      this.flip = (this.flip == 'inactive') ? 'active' : 'inactive';
    }
  
  }
  getBookMarkedFlashCards(){
    this.selfLearnService.getBookmarkedMemoryCards().subscribe((res:any) => {
      let data:any;
      data = res.data;
      this.cardOftheDayData = data;
      data.map((item:any) => {
        this.flashCardids.push(item.memoryCardId);
        
      })
      this.flashCardDataWithIds();
    })
  }
  flashCardDataWithIds(){
    this.selfLearnService.getFlashcardByFlashcardIds(this.flashCardids).subscribe((res:any) => {
      this.questionsData = res.data;
      this.currentQuestionData = this.questionsData[this.currentQuestionNumber];
      console.log(res);
    })
  }
  updateMemoryCard(cardDara:any,isRemebered:any){
    let tempCardData = this.cardOftheDayData.find((item:any) => item.memoryCardId ==cardDara.flashcardId)
    let payload:any = {
      "memoryCardId": cardDara.flashcardId,
      "examId": tempCardData.examId, 
      "subjectId": Number(tempCardData.subjectId),
      "chapterId": Number(tempCardData.chapterId),
      "isCompleted": true,
      "iremember": isRemebered,
      "gradeId": this.selfLearnService.getGradeId(),
    }
    console.log(payload);
    this.selfLearnService.updateCardOfDay(payload).subscribe((res:any) => {

    })
  }
  openMemoryCardCompletionDialog() {
    this.dialog.open(MemoryCardCompletionDialogComponent, { width:'500px', panelClass: 'SLV2-memorycard-completion-modal',data:{isFromMemoryCards:false} });
  }
  close(){
    let rounteUrl =  localStorage.getItem('previousScreen') ? localStorage.getItem('previousScreen') : 'selfLearn-V2'
    this.router.navigate([rounteUrl]);
  }
}
